function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "header/Units",
  transform: "translate(-1145.000000, -22.000000)",
  fill: "#5C7284",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Show/HIde-Trigger",
  transform: "translate(1134.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-18",
  transform: "translate(11.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-19"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-17",
  transform: "translate(0.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g192",
  transform: "translate(8.000000, 8.000000) scale(-1, 1) rotate(-180.000000) translate(-8.000000, -8.000000) "
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.787,15.7869988 C15.503,16.0710004 15.053,16.0710004 14.7688182,15.7869988 L10.1817273,11.1873363 L10.1817273,13.2528026 C10.1817273,13.654623 9.84590909,13.9964432 9.44427273,13.9964432 L9.439,13.9964432 C9.03736364,13.9964432 8.709,13.6628049 8.709,13.2609844 L8.70754545,9.43441724 C8.70754545,9.24150705 8.78354545,9.06477878 8.91990909,8.92841437 C9.05627273,8.79186814 9.24063636,8.72368593 9.43354545,8.72368593 L13.2542727,8.72368593 C13.6559091,8.72368593 13.9815455,9.04914232 13.9815455,9.45096279 C13.9815455,9.85296507 13.6559091,10.1782396 13.2542727,10.1782396 L11.1891818,10.1782396 L15.787,14.7680839 C16.071,15.0522673 16.071,15.5029972 15.787,15.7869988 M7.00518182,7.0353127 C7.14154545,6.89876647 7.21990909,6.69294712 7.21990909,6.49985511 L7.223,2.69292439 C7.223,2.29110393 6.90445455,1.99637498 6.50281818,1.99637498 L6.517,1.99637498 C6.11536364,1.99637498 5.81809091,2.26019466 5.81809091,2.66201513 L5.81809091,4.72820868 L1.26990909,0.209455736 C1.12772727,0.0674549287 0.913363636,0 0.727181818,0 C0.541,0 0.355,0.0783640816 0.213,0.220364888 C-0.071,0.504548321 -0.071,0.97964193 0.213,1.26382536 L4.73263636,5.81457849 L2.66809091,5.81457849 C2.26645455,5.81457849 1.94081818,6.14003489 1.94081818,6.54185535 C1.94081818,6.94367582 2.26645455,7.26913221 2.66809091,7.26913221 L6.489,7.26913221 C6.68190909,7.26913221 6.86863636,7.17167711 7.00518182,7.0353127",
  id: "icon_hide-nav",
  transform: "translate(8.000000, 8.000000) scale(-1, 1) rotate(-180.000000) translate(-8.000000, -8.000000) "
}))))))));

function SvgIconHideNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_hide nav") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHideNav);
export default __webpack_public_path__ + "static/media/icon_hide_nav.312fdbf3.svg";
export { ForwardRef as ReactComponent };